import DropdownRowBase from './DropdownRowBase'

import featureFlags from '../../../../lib/FeatureFlags'
import {railsUrl} from '../../../../lib/urlTools'

import {LogoutIcon} from '../../../assets/UserMenuIcons'


const SignOutRow = () => (
  <DropdownRowBase path={featureFlags.isEnabled('feedback_modal') ? 'logout-feedback' : null}>
    <a href={featureFlags.isEnabled('feedback_modal') ? null : railsUrl('sign_out')}>
      <LogoutIcon aria-hidden='true' className='dropdown-icon' focusable='false' />
      Log Out
    </a>
  </DropdownRowBase>
)

export default SignOutRow
